// ====================================================
// Intersection Observer
// ====================================================


const images = document.querySelectorAll('.lazy');

const options = {
    root: null, // it is the viewport
    threshold: 0,
    rootMargin: "400px"
};

const observer = new IntersectionObserver(function (entries, observer) {
    entries.forEach(entry => {
        if (!entry.isIntersecting) {
            return;
        } else {
            // console.log(entry.target);
            var image = entry.target;
            image.src = image.dataset.src;
            observer.unobserve(image);
            image.classList.remove('lazy');
            image.classList.remove('placeholderFix');
            image.removeAttribute('data-src');
        }
    })
}, options);

images.forEach(img => {
    observer.observe(img);
})


// ==================================================== //
// IO effects                                           //
// ==================================================== //

//              //
// locum page   //
//              //

if (location.pathname == "/locum") {
    // console.log("locum page");
    // Observed
    const statsSection = document.querySelector('#blue-banner-stats');
    const cardRow = document.querySelectorAll('.card-row');
    const cardRowImg = document.querySelectorAll('.card-img');
    const cardRowCard = document.querySelectorAll('.card');
    const footer = document.querySelector('footer');

    cardRow.forEach(cr => {
        cr.classList.add('fadeInEffect');
    })

    // Move up stats section
    // footer.style.visibility = "hidden";
    const ioStats = new IntersectionObserver(function (entries, ioStats) {
        entries.forEach(entry => {
            if (!entry.isIntersecting) {
                return;
            } else {
                // console.log(entry.target);
                var element = entry.target;
                element.classList.remove('moveUpEffect');
                ioStats.unobserve(element);
            }
        })
    },
        {
            root: null,
            threshold: 0,
            rootMargin: "-50px"
        });

    // Appear / disappear card
    let $screenWidth = $(window).width();

    const ioCard = new IntersectionObserver(function (entries, ioCard) {
        entries.forEach(entry => {
            if (!entry.isIntersecting) {
                return;
            } else {
                if ($screenWidth > 1101) {
                    // console.log(entry.target);
                    var element = entry.target;
                    element.classList.remove('fadeInEffect');
                    element.classList.remove('translateLeftEffect');
                    element.classList.remove('translateRightEffect');
                    ioCard.unobserve(element);
                } else {
                    // console.log(entry.target);
                    var element = entry.target;
                    element.classList.remove('fadeInEffect');
                    element.classList.remove('translateLeftEffect');
                    element.classList.remove('translateRightEffect');
                    ioCard.unobserve(element);
                }

            }
        })
    },
        {
            root: null,
            threshold: 0,
            rootMargin: "-130px"
        });



    // Observe
    ioStats.observe(statsSection);

    cardRow.forEach(cr => {
        ioCard.observe(cr);
    })

    cardRowImg.forEach(crImg => {
        ioCard.observe(crImg);
    })

    cardRowCard.forEach(crCard => {
        ioCard.observe(crCard);
    })
}

//              //
// Owner page   //
//              //

if (location.pathname == "/practice-owner") {
    // console.log("practice owner page");
    // Observed
    const cardRow = document.querySelectorAll('.card-row');
    const cardRowImg = document.querySelectorAll('.card-img');
    const cardRowCard = document.querySelectorAll('.card');

    cardRow.forEach(cr => {
        cr.classList.add('fadeInEffect');
    })


    // Appear / disappear card
    let $screenWidth = $(window).width();

    const ioCard = new IntersectionObserver(function (entries, ioCard) {
        entries.forEach(entry => {
            if (!entry.isIntersecting) {
                return;
            } else {
                if ($screenWidth > 1101) {
                    // console.log(entry.target);
                    var element = entry.target;
                    element.classList.remove('fadeInEffect');
                    element.classList.remove('translateLeftEffect');
                    element.classList.remove('translateRightEffect');
                    ioCard.unobserve(element);
                } else {
                    // console.log(entry.target);
                    var element = entry.target;
                    element.classList.remove('fadeInEffect');
                    element.classList.remove('translateLeftEffect');
                    element.classList.remove('translateRightEffect');
                    ioCard.unobserve(element);
                }

            }
        })
    },
        {
            root: null,
            threshold: 0,
            rootMargin: "-130px"
        });

    // Observe
    cardRow.forEach(cr => {
        ioCard.observe(cr);
    })

    cardRowImg.forEach(crImg => {
        ioCard.observe(crImg);
    })

    cardRowCard.forEach(crCard => {
        ioCard.observe(crCard);
    })
}


//              //
// Home page    //
//              //

if (location.pathname == "/") {
    // console.log('home');
    const vetSection = document.querySelector('.hero-vet');
    const ownerSection = document.querySelector('.hero-owner');
    const navbar = document.querySelector('header');

    const ioHero = new IntersectionObserver(function (entries, ioHero) {
        entries.forEach(entry => {
            if (!entry.isIntersecting) {
                return;
            } else {
                // console.log(entry.target);
                var element = entry.target;
                element.classList.remove('translateRightHomeEffect');
                element.classList.remove('translateLeftHomeEffect');
                element.classList.remove('translateDownEffect');
                ioHero.unobserve(element);
            }
        })
    },
        {
            root: null,
            threshold: 0,
            rootMargin: "0px"
        });

    ioHero.observe(vetSection);
    ioHero.observe(ownerSection);
    ioHero.observe(navbar);

}
const navbar = document.querySelector('header');

const ioHero = new IntersectionObserver(function (entries, ioHero) {
    entries.forEach(entry => {
        if (!entry.isIntersecting) {
            return;
        } else {
            // console.log(entry.target);
            var element = entry.target;
            element.classList.remove('translateDownEffect');
            ioHero.unobserve(element);
        }
    })
},
    {
        root: null,
        threshold: 0,
        rootMargin: "0px"
    });
ioHero.observe(navbar);


//              //
// Every pages  //
//              //
// console.log('every pages');

const titles = document.querySelectorAll('.title h2');
titles.forEach(title => {
    title.classList.toggle('fadeInEffect');
    title.classList.toggle('moveUpEffectSm');
    title.style.color = "red !important";
    // console.log('adsf');
})

const ioAllPages = new IntersectionObserver(function (entries, ioHero) {
    entries.forEach(entry => {
        if (!entry.isIntersecting) {
            return;
        } else {
            // console.log(entry.target);
            var element = entry.target;
            element.classList.remove('fadeInEffect');
            element.classList.remove('moveUpEffectSm');
            ioAllPages.unobserve(element);
        }
    })
},
    {
        root: null,
        threshold: 0,
        rootMargin: "-30px"
    });

titles.forEach(title => {
    ioAllPages.observe(title);
})